import type { SVGProps } from 'react';

import { Icon } from './Icon';

export function UploadFileIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <Icon viewBox="0 0 20 20" {...props}>
      <path
        d="M5 16.667c-.458 0-.85-.163-1.177-.49A1.605 1.605 0 0 1 3.333 15v-2.5h1.25V15c0 .069.024.13.073.177A.24.24 0 0 0 4.833 15.25h10.334a.24.24 0 0 0 .177-.073.24.24 0 0 0 .073-.177v-2.5h1.25V15c0 .458-.164.85-.49 1.177-.326.327-.719.49-1.177.49H5ZM9.375 5.875 7.042 8.208 6.167 7.292l3.833-3.834 3.833 3.834-.875.916-2.333-2.333v7.458H9.375V5.875Z"
        fill="currentColor"
      />
    </Icon>
  );
}
